import {Box, ChakraProps, Icon, Tooltip, Spinner} from "@chakra-ui/react";
import React from "react";

interface IconWithTooltipProps extends ChakraProps {
    icon?: any;
    tooltipMessage?: string;
    onClick?: () => void;  // Поддержка async функций
    isOutlined?: boolean;
    isHoverOutlined?: boolean;
    isDisabled?: boolean;
    color?: string;
    fontSize?: string;
    label?: string;
    isLoading?: boolean;
    backgroundColorIcon?: string;
}

const IconWithTooltip: React.FC<IconWithTooltipProps> = ({
                                                             icon,
                                                             tooltipMessage,
                                                             onClick,
                                                             fontSize = "1rem",
                                                             isOutlined = false,
                                                             isHoverOutlined = true,
                                                             isDisabled = false,
                                                             color,
                                                             label,
                                                             isLoading = false,
                                                             backgroundColorIcon,
                                                             ...props
                                                         }) => {
    const button = (
        <Box
            as="button"
            type="button"
            h={6}
            ml="0.2rem"
            _hover={{
                borderRadius: "10%",
                border: !isDisabled && isHoverOutlined ? "0.2px solid gray" : "none",
            }}
            border={isOutlined ? "1px solid red" : "none"}
            borderRadius="10%"
            display="inline-block"
            onClick={isDisabled || isLoading ? undefined : onClick}
            opacity={isDisabled ? 0.5 : 1}
            cursor={isDisabled || isLoading ? "not-allowed" : "pointer"}
            aria-disabled={isDisabled}
            color={color}
            {...props}
        >
            {isLoading ? (
                <Spinner size="sm"/>
            ) : label ? (
                <Box p="1px">{label}</Box>
            ) : (
                <Icon as={icon} backgroundColor={backgroundColorIcon} strokeWidth={1} fontSize={fontSize} cursor="inherit" color={color}/>
            )}
        </Box>
    );

    return (
        <Tooltip fontSize={14} hasArrow label={tooltipMessage} bg="gray.300" color="black">
            {isDisabled ? (
                <Box as="span" display="inline-block" lineHeight={0}>
                    {button}
                </Box>
            ) : (
                button
            )}
        </Tooltip>
    );
};

export default IconWithTooltip;
